import { gql } from '@common/hooks';

export const STAFFING_REQUEST_STATES_FRAGMENT = gql`
  fragment StaffingRequestStates on StaffingRequest {
    id

    canPending {
      value
    }

    canOpenUp {
      value
    }

    canHold {
      value
    }

    canUpdate {
      value
    }

    canCancel {
      value
    }
  }
`;
